module.exports = ".btnIrSistema {\r\n    background: #1d58a3;\r\n}\r\n\r\n.btnIrSistema:hover {\r\n    background: #2a7ae2;\r\n}"